// extracted by mini-css-extract-plugin
module.exports = {"planets-mobile-path":"styles__planets-mobile-path___29QwY","reverse":"styles__reverse___ONraJ"};